import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BonusesGetPublicQueryVariables = Types.Exact<{
  language: Types.Scalars['String']['input'];
  date: Types.Scalars['String']['input'];
}>;


export type BonusesGetPublicQuery = { __typename?: 'Query', bonus: Array<{ __typename?: 'bonus', template_id?: string | null, start_date?: any | null, end_date?: any | null, show_unauthenticated?: boolean | null, collection?: { __typename?: 'bonus_collections', translations?: Array<{ __typename?: 'bonus_collections_translations', display_name?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'bonus_translations', title?: string | null, subtitle?: string | null, description?: string | null, slug?: string | null, thumbnail?: { __typename?: 'directus_files', filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null } | null> | null }> };


export const BonusesGetPublicDocument = gql`
    query BonusesGetPublic($language: String!, $date: String!) {
  bonus(
    filter: {status: {_eq: "published"}, show_unauthenticated: {_eq: true}, start_date: {_lte: $date}, _or: [{end_date: {_gt: $date}}, {end_date: {_null: true}}], translations: {languages_language_code: {language_code: {_eq: $language}}}}
  ) {
    template_id
    start_date
    end_date
    show_unauthenticated
    collection(filter: {status: {_eq: "published"}}) {
      translations(
        filter: {languages_language_code: {language_code: {_eq: $language}}}
      ) {
        display_name
      }
    }
    translations(
      filter: {languages_language_code: {language_code: {_eq: $language}}}
    ) {
      title
      subtitle
      description
      slug
      thumbnail(filter: null) {
        filename_disk
        title
        width
        height
      }
    }
  }
}
    `;

/**
 * __useBonusesGetPublicQuery__
 *
 * To run a query within a React component, call `useBonusesGetPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useBonusesGetPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBonusesGetPublicQuery({
 *   variables: {
 *      language: // value for 'language'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useBonusesGetPublicQuery(baseOptions: Apollo.QueryHookOptions<BonusesGetPublicQuery, BonusesGetPublicQueryVariables> & ({ variables: BonusesGetPublicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BonusesGetPublicQuery, BonusesGetPublicQueryVariables>(BonusesGetPublicDocument, options);
      }
export function useBonusesGetPublicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BonusesGetPublicQuery, BonusesGetPublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BonusesGetPublicQuery, BonusesGetPublicQueryVariables>(BonusesGetPublicDocument, options);
        }
export function useBonusesGetPublicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BonusesGetPublicQuery, BonusesGetPublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BonusesGetPublicQuery, BonusesGetPublicQueryVariables>(BonusesGetPublicDocument, options);
        }
export type BonusesGetPublicQueryHookResult = ReturnType<typeof useBonusesGetPublicQuery>;
export type BonusesGetPublicLazyQueryHookResult = ReturnType<typeof useBonusesGetPublicLazyQuery>;
export type BonusesGetPublicSuspenseQueryHookResult = ReturnType<typeof useBonusesGetPublicSuspenseQuery>;
export type BonusesGetPublicQueryResult = Apollo.QueryResult<BonusesGetPublicQuery, BonusesGetPublicQueryVariables>;